export default __webpack_public_path__ + "static/media/share-icon.14b81d7d.svg";